import R from 'ramda'

const KEYWORD_DISPLAY_TYPE = 'Match Keyword'
const KEYWORD_TRIGGER_TYPE = 'KEYWORD'

const isKeywordFormTrigger = R.propEq('type', KEYWORD_DISPLAY_TYPE)

const convertKeywordFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(KEYWORD_TRIGGER_TYPE),
  data: R.prop('value'),
  operator: R.always('AND'),
  primary: R.T
})

export { isKeywordFormTrigger, convertKeywordFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/form-to-widget/keyword.js